import { isDevMode } from '@angular/core';
import { StoreDevtoolsConfig } from '@ngrx/store-devtools';

export const config: StoreDevtoolsConfig = { maxAge: 25, logOnly: !isDevMode(), connectInZone: true };
